'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Xhr = (function () {
    _createClass(Xhr, null, [{
        key: 'EXPIRED',

        /**
         *
         */
        value: function EXPIRED() {
            return 'EXPIRED';
        }

        /**
         *
         */
    }]);

    function Xhr($q, $http, localStorageService) {
        _classCallCheck(this, Xhr);

        this.$q = $q;
        this.$http = $http;
        this.localStorageService = localStorageService;

        this.settings = {
            baseUrl: '',
            ttl: 60 * 60 //1h
        };
    }

    /**
     *
     */

    _createClass(Xhr, [{
        key: 'setTTL',
        value: function setTTL(ttl) {
            this.settings.ttl = ttl;

            return this;
        }

        /**
         *
         */
    }, {
        key: 'setBaseUrl',
        value: function setBaseUrl(baseUrl) {
            this.settings.baseUrl = baseUrl;

            return this;
        }

        /**
         *
         */
    }, {
        key: 'get',
        value: function get(service) {
            var _this = this;

            var deferred = this.$q.defer(),
                url = this.settings.baseUrl + '/' + service;

            var cachedData = this.readCache(url);
            if (this.EXPIRED !== cachedData) {

                deferred.resolve(cachedData);

                return deferred.promise;
            }

            var promise = this.$http.get(url).then(function (response) {
                var responseData = response.data;
                _this.storeCache(url, responseData);

                deferred.resolve(responseData);

                return deferred.promise;
            }, this.error);

            return promise;
        }

        /**
         *
         */
    }, {
        key: 'storeCache',
        value: function storeCache(key, data) {
            var time = new Date();

            var store = {
                data: data,
                expires: Math.round(time.setSeconds(time.getSeconds() + this.settings.ttl) / 1000)
            };

            this.localStorageService.set(key, store);

            return this;
        }

        /**
         *
         */
    }, {
        key: 'readCache',
        value: function readCache(key) {
            var time = new Date();
            var now = Math.round(+time / 1000),
                cached = this.localStorageService.get(key);

            var expires = 'undefined' !== typeof cached && null !== cached && 'undefined' !== typeof cached.expires && null !== cached.expires ? cached.expires : 0;

            if (expires < now) {
                //cache is invalid
                return this.EXPIRED;
            }

            return cached.data;
        }
    }, {
        key: 'error',
        value: function error(text) {
            console.log('error fired');
            console.log(text);
        }
    }]);

    return Xhr;
})();

exports['default'] = Xhr;

Xhr.$inject = ['$q', '$http', 'localStorageService'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/utils/xhr.js
 ** module id = 32
 ** module chunks = 0
 **/